module.exports = __webpack_public_path__ + "static/media/act-2.b65b7507.mp3";